/* eslint-disable import/prefer-default-export */
export const getLimitFlag = (state) => state.limitFlag;

export const getInstantMatchFlag = (state) => state.instantMatchFlag;

export const getSubjectSelectionFlow = (goalUID, doubtUID) => (state) =>
  state.subjectSelectionFlow[goalUID]?.[doubtUID] || null;

export const getSubmittedFeedbacks = (doubtUID) => (state) =>
  state.submittedFeedbacks[doubtUID] || null;

export const getSelectedFeedbackChoice = (state) =>
  state.selectedfeedbackChoice || [];

export const getLimitFlagSetter = (state) => state.setLimitFlag;

export const getIsSubmittingSetter = (state) => state.setIsSubmitting;

export const getInstantMatchFlagSetter = (state) => state.setInstantMatchFlag;

export const getSubjectSelectionFlowSetter = (state) =>
  state.updateSubjectSelectionFlow;

export const getFeedbackSubmitter = (state) => state.submitFeedback;

export const getSelectedDoubtSolutionSetter = (state) =>
  state.setSelectedDoubtSolution;

export const getSelectedFeedbackChoiceSetter = (state) =>
  state.setSelectedFeedbackChoice;

export const getIsSubmitting = (state) => state.isSubmitting;
